<div class="link" [class.remote]="!local()" [title]="plugin().config?.description || ''">
  <a [routerLink]="['/tag', qualifiedTag()]">{{ plugin().name || plugin().tag }}</a>
  @if (plugin().name) {
    <span class="host">({{ qualifiedTag() }})</span>
  } @else if (origin()) {
    <span class="host">({{ origin() }})</span>
  }
</div>
<div class="info">
  <span [title]="plugin().modified?.toISO()" i18n>modified {{ plugin().modified | relative }}</span>
  @if (!local()) {
    &nbsp;<span i18n>on</span>&nbsp;<a [routerLink]="['/tag', plugin().origin]">{{ plugin().origin }}</a>
  }
</div>
<div class="actions">
  @if (!created() && store.account.admin) {
    <app-confirm-action [action]="copy$" i18n>install</app-confirm-action>
  } @else if (!local()) {
    <app-inline-button [action]="copy$" i18n>copy</app-inline-button>
  }
  @if (created() && local() && store.account.admin) {
    <a class="fake-link" (click)="editing.set(!editing())" i18n>@if (editFormDirty()) {*edit*} @else {edit}</a>
  } @else {
    <a class="fake-link" (click)="viewSource.set(!viewSource())" i18n>source</a>
  }
  @if (canDiff()) {
    <a class="fake-link diff-link" (click)="toggleDiff()" i18n>diff</a>
  }
  <a class="fake-link" (click)="download()" i18n>download</a>
  @if (plugin().config?.export) {
    <a class="fake-link" (click)="export()" i18n>export</a>
  }
  @if (created() && store.account.admin) {
    <app-confirm-action [action]="delete$" i18n>delete</app-confirm-action>
  }
</div>

@if (editing()) {
  <form class="form" [formGroup]="editForm" (ngSubmit)="save()">

    <app-plugin-form [group]="editForm"
                     [configErrors]="configErrors()"
                     [defaultsErrors]="defaultsErrors()"
                     [schemaErrors]="schemaErrors()" />

    @for (e of serverError(); track e) {
      <span><!-- Unexpected Error --></span>
      <div class="error">{{ e }}</div>
    }

    <span><!-- Buttons --></span>
    <span class="buttons right floating">
      @if (saving()) {
        <app-loading [inline]="true" />
      }
      <button type="submit" [disabled]="saving() || submitted() && !editFormValid()" i18n>save</button>
      <button type="button" (click)="cancelEdit()" i18n>cancel</button>
    </span>
  </form>
} @else if (viewSource()) {
  <form class="form" [formGroup]="editForm">
    <app-plugin-form [group]="editForm" />
  </form>
} @else if (diffing() && diffLocal() && diffRemote()) {
  <div class="diff-view form">
    <app-diff #diffEditor
              [original]="diffLocal()!"
              [modified]="diffRemote()!"
              [readOnly]="!store.account.admin" />

    @for (e of serverError(); track e) {
      <span><!-- Unexpected Error --></span>
      <div class="error">{{ e }}</div>
    }

    <span><!-- Buttons --></span>
    <span class="buttons right floating">
      @if (saving()) {
        <app-loading [inline]="true" />
      }
      @if (store.account.admin) {
        <button type="button" class="save-diff" [disabled]="saving()" (click)="saveDiff()" i18n>save</button>
      }
      <button type="button" (click)="diffing.set(false)" i18n>cancel</button>
    </span>
  </div>
} @else {
  @for (e of serverError(); track e) {
    <div class="error">{{ e }}</div>
  }
}
